import React, { useEffect, useRef } from "react";
import _ from "lodash";

import {
  calculatePrefixForExercise,
  buildSupersets,
} from "../../../../utils/prefix-calculator";
import { getUserToRequest } from "../../settings/manage-coaches/utils/manage-coaches-utils";
import { formattedTarget } from "../../../../utils/actuals";
import SvgIcon from "../../../../parts/SvgIcon";
import { getExerciseName } from "../../../../parts/modals/learn-more/blockHelpers";
import { getComplexSetReps } from "../../../../utils/complex";
import MetconDisplay from "../../../../parts/metcon/MetconDisplay";

const ExercisePreview = (props) => {
  const { exercise, exercises, exerciseOrder, locals } = props;
  const {
    activeUser,
    withWeight,
    fromMetric,
    organizationOwner,
    activeUserToRequest,
  } = locals;
  const userToMeasure = getUserToRequest(activeUser, organizationOwner);

  const intensityMeasure =
    _.get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
      ? "RPE"
      : "RiR";
  const isRiR = intensityMeasure === "RiR";
  const isPrimary = exercise.type === "primary";
  const isMetcon = exercise.primary === "metcon";
  const supersets = buildSupersets(exercises);
  const activeExerciseIndex = _.findIndex(
    exercises,
    (ex) => ex._id == exercise._id
  );
  const isLast = exerciseOrder === exercises.length - 1;
  const nextExercise = !isLast && exercises[activeExerciseIndex + 1];
  const isSuperset = exercise.nextSuperset === nextExercise?._id;
  // Already in KG, so set.load / defaultRepMax will calculate correctly since both are stored in KG
  // gets primary repmax of the exercise if exercise type is primary else
  // if secondary, use secondary rm, else if assistant just use active user's squat (RM doesn't really matter for assistant)
  // if all else fails, default to 0
  const defaultRepMax = _.get(
    exercise,
    isPrimary ? `repMaximums.${exercise.primary}` : "secondaryRepMaximum",
    _.get(activeUser, "repMaximums.squat", 0)
  );
  //defaultRepMax = Math.round(defaultRepMax, 0)
  const textareaRef = useRef(null);
  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [exercise.notes]);

  return (
    <li
      className={`exercise ${isSuperset ? "is-superset" : ""}`}
      id={exercise._id}
    >
      {_.map(exercise.sets, (set, idx) => {
        const percentRM = _.round(
          (_.get(set, "load", 0) / defaultRepMax) * 100,
          1
        );

        const isPowerlifting =
          exercise.type === "primary" || exercise.type === "secondary";

        let units = activeUser.units;
        let round = userToMeasure.round;
        if (locals.athlete) {
          units = locals.athlete.units;
          round = locals.athlete.round;
        }

        // assumption is set.load is always stored as KG; so convert to user's unit
        const precision = units === "metric" ? 2 : 1;

        const load = set.load
          ? withWeight(
              _.round(fromMetric(set.load, units, round), precision),
              units
            )
          : "";

        let prefix = "";
        if (activeExerciseIndex >= 0) {
          prefix = calculatePrefixForExercise(exercise._id, supersets);
        }

        let complexReps;
        if (exercise?.exercises?.length)
          complexReps = getComplexSetReps(exercise.exercises, idx);

        return (
          <div
            className="exercise-container"
            key={`${exercise._id}_set${idx}}`}
          >
            {idx === 0 && (
              <div
                className={`title-container ${exerciseOrder > 0 ? "mt-6" : ""}`}
              >
                {idx === 0 && <span className="calendar-prefix">{prefix}</span>}
                {idx !== 0 && <span className="calendar-prefix"></span>}
                {idx === 0 && (
                  <p className="font-semibold">{getExerciseName(exercise)}</p>
                )}
                {idx != 0 && <span />}
              </div>
            )}

            {idx === 0 && isMetcon && (
              <div className="mb-4">
                <MetconDisplay exercise={exercise} compact />
              </div>
            )}

            <div className="workout-target">
              <div className="circle-status target"></div>
              <p className="p4">
                {formattedTarget(
                  set,
                  isPowerlifting,
                  percentRM,
                  units,
                  load,
                  intensityMeasure,
                  isRiR,
                  false,
                  complexReps
                )}
              </p>
            </div>
          </div>
        );
      })}
      {exercise.notes && (
        <div className="exnotes">
          <SvgIcon src="/img/new-icons/message-icon.svg" />
          <textarea
            id={`${exercise._id}_notes`}
            name="notes"
            value={exercise.notes}
            readOnly
            ref={textareaRef}
          />
        </div>
      )}
    </li>
  );
};

export default ExercisePreview;
